import React from 'react';
// import '../styles/LoanTypes.css';

const LoanTypes = () => {
    return (
        <div className="loan-types">
            <h1>Types of Loans</h1>
            <ul>
                <li>📌 Personal Loan</li>
                <li>📌 Home Loan</li>
                <li>📌 Car Loan</li>
                <li>📌 Education Loan</li>
                <li>📌 Business Loan</li>
            </ul>
        </div>
    );
};

export default LoanTypes;
